module.exports = __webpack_public_path__ + "img/apply_buy_2.5f765922.png";